import { gql } from '@apollo/client';

export const DELETE_USER_MUTATION = gql`
    mutation deleteUser($input: DeleteUserInput!) {
        deleteUser(input: $input) {
            message
        }
    }
`;
